export const env = {
  appEnv: import.meta.env.VITE_APP_ENV,
  baseUrl: 'https://sandbox.doitpay.co/',
  urlPublic: 'https://sandbox.doitpay.co/',
  siteKeyCloudflare: import.meta.env.VITE_SITE_KEY_CLOUDFLARE,
  urlDoitpayCheckout: 'https://pias.checkout.doitpay.co/',
  registerEmailMinute: import.meta.env.VITE_REGISTER_EMAIL_MINUTE,
  registerEmailSeconds: import.meta.env.VITE_REGISTER_EMAIL_SECONDS,
  doitpayMerchantIsLive: import.meta.env.VITE_DOITPAY_MERCHANT_ISLIVE,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  notificationTabStatus: import.meta.env.VITE_DOITPAY_STATUS_NOTIFICATION,
};
